<mat-dialog-content>
    <div style="text-align: center;">
        <h2>Your session has expired.  Please login again.</h2>
        <button mat-raised-button color="accent" (click)="login()">Login</button>
        <button mat-raised-button color="warn" (click)="cancel()" style="margin-left: 10px;">Cancel</button>
    </div>
</mat-dialog-content>